if (!customElements.get('quick-cart-drawer')) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
        this.parentElement.addEventListener('shopify:section:select', () => this.open());
        this.parentElement.addEventListener('shopify:section:deselect', () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }

      this.querySelector('.button--close').addEventListener('click', this.close.bind(this));
      this.querySelector('.quick-cart-drawer__backdrop').addEventListener('click', this.close.bind(this));

      this.querySelector('.quick-cart-drawer__blocks').addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === 'Tab';

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll('.quick-cart-drawer__trigger').forEach(element => {
          if (!element._init) {
            // Daha önce eklenmiş mi kontrol edin
            element.addEventListener('click', event => {
              this.fetchProductForQuickCartDrawer(event);
            });
            element._init = true; // Eklenmiş olarak işaretleyin
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    async fetchProductForQuickCartDrawer(event) {
      /** stop autoplay on quick cart trigger */
      if (event.target.closest('card-product-slider')) {
        event.target.closest('card-product-slider').slider.autoplay.stop();
        event.target.closest('card-product-slider').classList.add('product--open-on-quick-cart');
      }

      const isRecommendations = event.target.classList.contains('quick-cart-drawer__trigger--recommendations');

      const productCard = event.target.closest('product-card');
      let productOptions = null;

      if (!isRecommendations) {
        if (!productCard) return;
        // get all checked options
        productOptions = productCard.querySelectorAll('input[type="radio"]:checked, select');
      }

      const trigger = event.target.closest('[data-product-url]');
      let quickCartVariantId = '';
      if (productCard) {
        const variantInput = productCard.querySelector('input[name="id"]');
        if (variantInput) quickCartVariantId = variantInput.value;
      }
      // A trigger outside a product card (look builder pieces) names the variant to open itself.
      if (!quickCartVariantId && trigger.dataset.variantId) quickCartVariantId = trigger.dataset.variantId;
      trigger.classList.toggle('is--loading');
      try {
        // if root contains locale, add locale to productUrl as prefix
        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const variantParam = quickCartVariantId ? `&variant=${quickCartVariantId}` : '';
        const productCardResponse = await fetch(`${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart${variantParam}`);
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const tempContainer = document.createElement('DIV');
        tempContainer.insertAdjacentHTML('beforeend', productCardHTML);
        if (!tempContainer.querySelector('.quick-cart-product')) return;

        const quickCartProduct = tempContainer.querySelector('.quick-cart-product');

        if (!isRecommendations) {
          // Sync radios in fetched markup, then explicitly recompute variant state.
          const qcProductCard = quickCartProduct.querySelector('product-card');
          productOptions.forEach(productOption => {
            let productOptionName = productOption.name;
            const optionSectionIdAttribute = productOption.dataset?.sectionId;

            if (optionSectionIdAttribute) {
              productOptionName = productOptionName.replace(optionSectionIdAttribute, '');
            }

            const quickCartOptionName = `${productOptionName}-quick-cart-product`;

            // uncheck all radios for this option
            qcProductCard.querySelectorAll(`[name="${CSS.escape(quickCartOptionName)}"]`).forEach(radioInput => {
              radioInput.checked = false;
              radioInput.removeAttribute('checked');
              radioInput.closest('li')?.classList.remove('checked');
            });

            const quickCartDrawerOption = qcProductCard.querySelector(
              `[name="${CSS.escape(quickCartOptionName)}"][value="${CSS.escape(productOption.value)}"]`
            );
            const quickCartDrawerOptionLabel = quickCartDrawerOption?.parentElement?.parentElement?.querySelector('legend');

            if (quickCartDrawerOption) {
              quickCartDrawerOption.checked = true;
              quickCartDrawerOption.setAttribute('checked', '');
              if (quickCartDrawerOptionLabel) {
                const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
                if (quickCartDrawerOptionLabelSpan) {
                  quickCartDrawerOptionLabelSpan.innerHTML = productOption.value;
                }
              }
              quickCartDrawerOption.closest('li')?.classList.add('checked');
            }
          });

          if (quickCartVariantId) {
            const variantIdInput = qcProductCard.querySelector('input[name="id"]');
            if (variantIdInput) {
              variantIdInput.value = quickCartVariantId;
            }
          }
        }

        // Append synced quick-cart markup into drawer
        this.querySelector('.quick-cart-drawer__main').innerHTML = '';
        this.querySelector('.quick-cart-drawer__main').append(quickCartProduct);

        this.sliderInstance = new Swiper('.quick-cart-drawer__media-swiper', {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: {
            enabled: true
          },
          breakpoints: {
            750: {
              slidesPerView: 2
            }
          }
        });

        const initiallySelectedVariant = this.syncCurrentQuickCartVariantState(quickCartVariantId);
        this.syncMediaForSelectedVariant(initiallySelectedVariant);
      } catch (error) {
        // console.log(error);
      } finally {
        trigger.classList.toggle('is--loading');

        // short wait before opening drawer
        setTimeout(() => {
          this.open();
        }, 500);

        // add small delay to open drawer
        // this.open();

        this.bindVariantOptionListeners();
      }
    }

    bindVariantOptionListeners() {
      this.querySelector('.quick-cart-drawer__main')
        ?.querySelectorAll('.variant-option-radio-input')
        .forEach(radioInput => {
          if (radioInput.dataset.quickCartListenerBound === 'true') return;
          radioInput.dataset.quickCartListenerBound = 'true';

          radioInput.addEventListener('change', event => {
            const quickCartDrawerOptionLabel = event.target.parentElement.parentElement.querySelector('legend');
            const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
            if (quickCartDrawerOptionLabelSpan) {
              quickCartDrawerOptionLabelSpan.innerHTML = event.target.value;
            }

            const selectedVariant = this.syncCurrentQuickCartVariantState();
            const changedFieldset = event.target.closest('.js-product-card-options');
            const isSwatchOption = changedFieldset?.querySelector('.button--swatch');
            const optionIndexMatch = event.target.name?.match(/option\[(\d+)\]/);
            const changedOptionIndex = optionIndexMatch ? Number(optionIndexMatch[1]) : null;

            if (isSwatchOption || changedOptionIndex === 1) {
              requestAnimationFrame(() => {
                const latestVariantId = this.querySelector(".quick-cart-drawer__main .product-card__add-to-cart--form input[name='id']")?.value
                  || selectedVariant?.id;
                if (latestVariantId) {
                  this.refreshQuickCartForVariant(latestVariantId);
                }
              });
              return;
            }

            this.syncMediaForSelectedVariant(selectedVariant);
          });
        });
    }

    syncCurrentQuickCartVariantState(preferredVariantId = '') {
      const quickCartProductCard = this.querySelector('.quick-cart-drawer__main product-card');
      if (!quickCartProductCard) return null;

      if (!quickCartProductCard.variantsObj && typeof quickCartProductCard.getVariantsData === 'function') {
        quickCartProductCard.getVariantsData();
      }

      const productVariantsData = quickCartProductCard.variantsObj || [];
      if (!productVariantsData.length) return null;

      const variantState = quickCartProductCard.findCurrentVariantFromOptionRadioInputs?.() || {};
      const selectedOptions = variantState.currentCheckedOptions || [];
      let selectedVariant = null;

      if (variantState.currentVariantId) {
        selectedVariant = productVariantsData.find(variant => String(variant.id) === String(variantState.currentVariantId));
      }

      if (!selectedVariant && selectedOptions.length) {
        selectedVariant = productVariantsData.find(variant => {
          return selectedOptions.every((selectedValue, index) => variant[`option${index + 1}`] === selectedValue);
        });
      }

      if (!selectedVariant && preferredVariantId) {
        selectedVariant = productVariantsData.find(variant => String(variant.id) === String(preferredVariantId));
      }

      const variantIdInput = quickCartProductCard.querySelector(".product-card__add-to-cart--form input[name='id']");
      if (!selectedVariant && variantIdInput?.value) {
        selectedVariant = productVariantsData.find(variant => String(variant.id) === String(variantIdInput.value));
      }

      if (selectedVariant && variantIdInput) {
        variantIdInput.value = selectedVariant.id;
      }

      if (selectedVariant) {
        quickCartProductCard.updatePriceForVariant?.(selectedVariant.id);
        quickCartProductCard.updateDiscountBadgeForVariant?.(selectedVariant.id);
      }

      quickCartProductCard.disableAddToCartButons?.();
      quickCartProductCard.setCartButtonState?.();

      return selectedVariant || null;
    }

    applyAvailabilityFromVariants(productCard, variantsData) {
      const selectedByPosition = {};
      const optionFieldsets = Array.from(productCard.querySelectorAll('.js-product-card-options'));
      const fieldsetsData = optionFieldsets
        .map((fieldset, index) => {
          const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          if (!radios.length) return null;

          const optionIndexMatch = radios[0].name?.match(/option\[(\d+)\]/);
          const optionPosition = optionIndexMatch ? Number(optionIndexMatch[1]) : index + 1;

          return { fieldset, radios, optionPosition };
        })
        .filter(Boolean);

      fieldsetsData.forEach(({ fieldset, radios, optionPosition }, fieldsetIndex) => {
        const previousOptionPositions = fieldsetsData
          .slice(0, fieldsetIndex)
          .map(item => item.optionPosition);

        radios.forEach(radioInput => {
          const radioValue = radioInput.value;
          const isAvailable = variantsData.some(variant => {
            if (!variant.available) return false;
            if (variant[`option${optionPosition}`] !== radioValue) return false;

            for (const previousOptionPosition of previousOptionPositions) {
              const selectedValue = selectedByPosition[previousOptionPosition];
              if (selectedValue && variant[`option${previousOptionPosition}`] !== selectedValue) {
                return false;
              }
            }

            return true;
          });

          radioInput.toggleAttribute('disabled', !isAvailable);
          radioInput.closest('.button--variant')?.classList.toggle('disabled', !isAvailable);
          radioInput.closest('li')?.classList.toggle('disabled', !isAvailable);
        });

        let checkedOption = fieldset.querySelector('input[type="radio"]:checked');
        if (!checkedOption || checkedOption.disabled) {
          radios.forEach(radioInput => {
            radioInput.checked = false;
            radioInput.removeAttribute('checked');
          });
          checkedOption = radios.find(radioInput => !radioInput.disabled) || null;
        }

        if (checkedOption) {
          checkedOption.checked = true;
          checkedOption.setAttribute('checked', '');
          selectedByPosition[optionPosition] = checkedOption.value;
        } else {
          delete selectedByPosition[optionPosition];
        }

        radios.forEach(radioInput => {
          const isChecked = radioInput === checkedOption;
          radioInput.closest('.button--variant')?.classList.toggle('checked', isChecked);
          radioInput.closest('li')?.classList.toggle('checked', isChecked);
        });

        const optionLegendValue = fieldset.querySelector('[data-selected-variant]');
        if (optionLegendValue && checkedOption) {
          optionLegendValue.innerHTML = checkedOption.value;
        }
      });

      return selectedByPosition;
    }

    syncMediaForSelectedVariant(selectedVariant) {
      const featuredMedia = selectedVariant?.featured_media;
      if (!featuredMedia) return;

      const currentSlides = this.querySelectorAll('.quick-cart-drawer__media-swiper .swiper-slide[data-media-id]');
      const mediaExists = Array.from(currentSlides).some(slide => Number(slide.dataset.mediaId) === featuredMedia.id);

      if (!mediaExists) {
        this.refreshMediaForVariant(selectedVariant.id);
      } else {
        this.setActiveMedia(featuredMedia.id);
      }
    }

    async refreshQuickCartForVariant(variantId) {
      try {
        const productUrl = this.querySelector('.quick-cart-product[data-product-url]')?.dataset?.productUrl
          || this.querySelector('.product__title')?.getAttribute('href')
          || window.location.pathname;

        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const response = await fetch(`${fetchPrefix}${productUrl}/?view=quick-cart&variant=${variantId}`);
        if (!response.ok) return;

        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const refreshedQuickCartProduct = tempDiv.querySelector('.quick-cart-product');
        if (!refreshedQuickCartProduct) return;

        this.querySelector('.quick-cart-drawer__main').innerHTML = '';
        this.querySelector('.quick-cart-drawer__main').append(refreshedQuickCartProduct);

        if (this.sliderInstance) {
          this.sliderInstance.destroy(true, true);
        }
        this.sliderInstance = new Swiper('.quick-cart-drawer__media-swiper', {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: {
            enabled: true
          },
          breakpoints: {
            750: {
              slidesPerView: 2
            }
          }
        });

        const selectedVariant = this.syncCurrentQuickCartVariantState(variantId);
        this.syncMediaForSelectedVariant(selectedVariant);
        this.bindVariantOptionListeners();
      } catch (error) {
        // silent fail
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll('[data-media-id]')).find(media => Number(media.dataset.mediaId) === id);
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    async refreshMediaForVariant(variantId) {
      try {
        const productUrl = this.querySelector('.quick-cart-product[data-product-url]')?.dataset?.productUrl
          || this.querySelector('.product__title')?.getAttribute('href')
          || window.location.pathname;

        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const response = await fetch(`${fetchPrefix}${productUrl}/?view=quick-cart&variant=${variantId}`);
        if (!response.ok) return;

        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const newSwiperWrapper = tempDiv.querySelector('.quick-cart-drawer__media-swiper .swiper-wrapper');
        if (!newSwiperWrapper) return;

        const currentWrapper = this.querySelector('.quick-cart-drawer__media-swiper .swiper-wrapper');
        if (currentWrapper) {
          currentWrapper.innerHTML = newSwiperWrapper.innerHTML;
        }

        if (this.sliderInstance) {
          this.sliderInstance.destroy(true, true);
        }
        this.sliderInstance = new Swiper('.quick-cart-drawer__media-swiper', {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: { enabled: true },
          breakpoints: { 750: { slidesPerView: 2 } }
        });
      } catch (e) {
        // silent fail
      }
    }

    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector('body').classList.add('overflow-hidden');
      const quickCartDrawer = document.querySelector('.quick-cart-drawer__blocks');
      const closeButton = quickCartDrawer.querySelector('.button--close');
      quickCartDrawer.setAttribute('tabindex', '0');
      closeButton.setAttribute('tabindex', '0');
      this.classList.add('is--open');
      this.opened();

      const firstFocusableElement = this.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close() {
      this.toggleState = false;

      const shopTheLookDrawer = document.querySelector('shop-the-look-drawer');

      if (shopTheLookDrawer && !shopTheLookDrawer.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
      if (!shopTheLookDrawer) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
      this.classList.remove('is--open');
      this.closed();
      this.toggleAriaExpanded();

      /** start autoplay on quick cart drawe close */
      if (document.querySelector('card-product-slider.product--open-on-quick-cart')) {
        document.querySelector('card-product-slider.product--open-on-quick-cart').slider.autoplay.start();
        document.querySelector('card-product-slider.product--open-on-quick-cart').classList.remove('product--open-on-quick-cart');
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest('button')) event.target.closest('button').setAttribute('aria-expanded', true);
        this.querySelector('.button--close').setAttribute('aria-expanded', true);
      } else {
        document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach(button => {
          button.setAttribute('aria-expanded', false);
        });
      }
    }

    opened() {
      const openedEvent = new Event('opened', { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event('closed', { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define('quick-cart-drawer', QuickCartDrawer);
}
